var _defs, _path, _g, _g2, _g3, _g4, _g5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg401UnauthorisedIllustration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 800 800",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #deeff9;\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n\n      .cls-3 {\n        fill: #c59d72;\n      }\n\n      .cls-4 {\n        fill: #58afe2;\n      }\n\n      .cls-5 {\n        clip-path: url(#clippath-1);\n      }\n\n      .cls-6 {\n        fill: #a5845f;\n      }\n\n      .cls-7 {\n        fill: #ababaa;\n      }\n\n      .cls-8 {\n        fill: #f1f2f2;\n      }\n\n      .cls-9 {\n        fill: #bc966e;\n      }\n\n      .cls-10 {\n        fill: #e95c2b;\n      }\n\n      .cls-11 {\n        fill: #ccc;\n      }\n\n      .cls-12 {\n        clip-path: url(#clippath-2);\n      }\n\n      .cls-13 {\n        fill: gray;\n      }\n\n      .cls-14 {\n        fill: #fdc24e;\n      }\n\n      .cls-15 {\n        fill: none;\n        stroke: #e6b149;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 2px;\n      }\n\n      .cls-16 {\n        fill: #4e3a22;\n      }\n\n      .cls-17 {\n        clip-path: url(#clippath);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M452.69,378.1c-.14,18.47-11.3,34.92-27.9,41.33-22.76,8.79-42.49-6.41-43.34-7.08-8.31-22.5-6.6-30.37-3.16-33.22,1.99-1.65,5.43-2.33,8.27-6.2,2.38-3.25,2.96-6.87,3.1-9.3,16.3-3.55,32.6-7.11,48.9-10.66-.33,1.28-2.28,9.35,2.76,16.86,3.92,5.84,9.66,7.76,11.37,8.27Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M517,635.37h-230.05c-4.06,0-7.66-2.61-8.92-6.47l-50.68-154.8c-1.99-6.07,2.54-12.31,8.92-12.31h219.95c4.06,0,7.66,2.61,8.92,6.47l49.98,152.65,3.85,11.76c.44,1.34-.56,2.71-1.96,2.71Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 201.62,
    y: 461.79,
    width: 292.4,
    height: 18.6
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M188.88,357.59l444.94-94.43c14.33-2.21,22.4,6.73,22.41,24.03.03,132.94-.15,265.87-.27,398.81H115.15l50.01-303.57c2.04-12.37,11.45-22.23,23.72-24.83Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M452.69,378.1c-.14,18.47-11.3,34.92-27.9,41.33-22.76,8.79-42.49-6.41-43.34-7.08-8.31-22.5-6.6-30.37-3.16-33.22,1.99-1.65,5.43-2.33,8.27-6.2,2.38-3.25,2.96-6.87,3.1-9.3,16.3-3.55,32.6-7.11,48.9-10.66-.33,1.28-2.28,9.35,2.76,16.86,3.92,5.84,9.66,7.76,11.37,8.27Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-17"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 411.45,
    cy: 351.66,
    rx: 37.71,
    ry: 27.9
  }))), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 353.54,
    cy: 286.45,
    rx: 11.88,
    ry: 17.05
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 460.34,
    cy: 291.22,
    rx: 17.05,
    ry: 11.88,
    transform: "translate(124.48 720.08) rotate(-84.25)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M420.03,202.7c-16.1-2.87-32.89,1.66-46.54,11.65-19.42,14.21-28.66,38.54-24.48,62.24,3.12,17.7,6.25,35.41,9.37,53.11,3.91,22.18,22,39.48,44.44,41.46.63.06,1.27.1,1.92.13,4.02.21,7.82-.03,11.38-.62,20.4-3.36,36.43-19.41,40.45-39.68,3.89-19.61,5.7-39.21,8.81-58.82,2.39-15.1-.33-30.69-8.48-43.62s-21.3-23.07-36.87-25.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M479,213.2c-1.94-.89-3.41,1.68-9.18,3.11-8.43,2.09-15.72,1.88-20.59,1.32,12.82-5.07,18.01-7.9,17.49-9.59-.93-3.06-13.44,1.8-33.06-4.13-3.16-.95-4.16-1.85-8.06-3.06-5.04-1.61-12.65-3.42-21.91-3.14-3.61.11-25.56,1.09-41.36,15.18-4.24-5.77-4.38-11.21-6.17-11.04-2.05.19-3.95,7.56-3.1,14.46.17,1.35.44,2.69.8,4.02-3.29-2.13-5.52-4.52-5.96-4.02-.49.55,1.53,4.17,5.35,7.58-9.96,16.81-6.96,35.99-5.37,46.16,1.03,6.6,3.62,17.56,4.15,17.55.24,0-1.97-12.66,5.17-25.83.96-1.77,2.94-5.4,6.24-8.64,9.68-9.47,24.18-9.04,27.86-8.93,21.13.63,23.44,14.12,46.49,17.56,5.3.79,14.54,2.17,23.32-.62,3.69,9.65-.74,23.14.44,23.35,1.13.21,7.03-11.75,5.34-25.91,1-.59,1.98-1.24,2.92-1.99,15.67-12.27,15.3-40.6,9.18-43.4Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M414.46,321.13c-3.28,2.75-11.33.1-12.24-4.03-1.1-5.02,1.49-9.32,2.72-13.88.33-1.23.25-3.13,2.07-2.93,0,0,.72.05,1.36.58.85.69.21,4.08-1.59,8.29-.31.6-2.43,4.83-.59,7.28.71.95,1.82,1.36,3.22,1.88,3.17,1.17,5.57.7,5.8,1.57.14.52-.62,1.14-.75,1.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.44,341.27c7.16-1.28,11.44-5.64,12.72-7.04l-26.63,5.07c1.74.86,7.06,3.2,13.91,1.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.44,278.96c6.16-3.5,11.83-.37,18.38,1.82-3.62-7.11-13.68-9.6-18.81-5.39-.91.74-2,1.5-1.47,2.93.32.85,1.27.99,1.89.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.75,276.95c.59.41,1.55.37,1.95-.45.67-1.37-.34-2.23-1.17-3.06-4.68-4.7-14.94-3.23-19.25,3.48,6.74-1.52,12.69-4.06,18.47.03Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 384.86,
    cy: 285.77,
    r: 4.74
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 433.73,
    cy: 288.63,
    r: 4.74
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M664.35,650.04c-12.45,21.19-38.37,27.32-62.08,30.53-22.65,3.06-51.99,4.47-97.63,6.43-23.33,1-46.83,1.51-70.23,1.51-12.8,0-25.56-.16-38.26-.45l1.37-57.85.09-4.12c34.54.82,69.65.48,104.35-1.01,15.53-.67,29.04-1.26,40.97-1.88,16.05-.83,12.65-.66,23.88-1.79,4.03-.4,7.56-.83,10.65-1.24,9.92-1.35,15.87-11.74,12.02-20.98-4.09-9.81-11.35-22.99-23.91-39.54-3.61-4.75-7.43-9.5-11.47-14.19l68.12-36c4.7,5.67,9.15,11.39,13.32,17.12,36.67,50.44,46.63,93.14,28.8,123.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M314.59,505.03l-.25,2.18c-17.26,14.87-35.34,32.4-50.11,50.4-27.26,33.22-28.35,49.91-27.14,52.57.55,1.21,6.21,6.53,23.88,10.41l-13.31,60.55c-34.26-7.53-56.82-22.79-67.04-45.38-14.32-31.64-2.31-71.16,35.7-117.48,13.5-16.45,30.38-33.81,48.7-50.27.33.27.69.53,1.06.75l44.01,27.03c3.16,1.94,4.92,5.54,4.5,9.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M542.87,617.8c.58,1.85.56,3.71.08,5.39-11.92.62-25.44,1.21-40.97,1.88-34.71,1.49-69.81,1.83-104.35,1.01l-.09,4.12h-86.27c-5.71,0-10.16-4.97-9.52-10.64l12.59-112.35.25-2.18c.41-3.69-1.34-7.28-4.5-9.23l-44.01-27.03c-.37-.23-.73-.49-1.06-.75-4.12-3.37-4.74-9.61-1.11-13.73l41.25-46.84c8.43-9.57,19.58-16.35,31.97-19.42,14.76-3.66,29.52-7.31,44.28-10.97,4.14,13.42,16.07,22.58,28.93,22.73,15.47.18,29.64-12.69,31-29.96l37.29-2.23c20.01-1.2,39.56,6.25,53.71,20.45l100.26,100.67c4.24,4.26,3.55,11.31-1.42,14.68l-8.92,6.04-51.59,34.96-15.83,10.74c-4.03,2.73-9.47,2-12.65-1.69-2.04-2.38-37.37-64.8-39.89-64.8l40.58,129.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M372.7,382.66c5.88,17.59,22.66,29,40.3,27.9,19.55-1.22,35.91-17.56,37.2-38.23"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-15",
    x1: 549.38,
    y1: 543.84,
    x2: 622.74,
    y2: 493.21
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M517,635.37h-230.05c-4.06,0-7.66-2.61-8.92-6.47l-50.68-154.8c-1.99-6.07,2.54-12.31,8.92-12.31h219.95c4.06,0,7.66,2.61,8.92,6.47l49.98,152.65,3.85,11.76c.44,1.34-.56,2.71-1.96,2.71Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 201.62,
    y: 461.79,
    width: 292.4,
    height: 18.6
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 457.08,
    cy: 470.82,
    r: 3.44
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 448.13,
    cy: 470.82,
    r: 3.44
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 439.17,
    cy: 470.82,
    r: 3.44
  }))))), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M486.78,688.06h-232.9c-4.06,0-7.66-2.61-8.92-6.47l-50.68-154.8c-1.99-6.07,2.54-12.31,8.92-12.31h219.95c4.06,0,7.66,2.61,8.92,6.47l49.98,152.65,4.73,14.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M545.01,688.06h-58.23l-4.73-14.46h70.86c4.02,6.25-.47,14.46-7.9,14.46Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M340.4,615.65c-4.33-22.83-26.88-19.49-30.53-18.8-.26.05-.38.33-.25.59l7.54,14.95c.35.69,1.14,1.08,1.81.91,11.16-2.95,19.24,1.39,21.1,2.54.17.11.36,0,.33-.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M341.07,615.65c-3.72-22.83,20.01-19.49,23.9-18.8.28.05.5.33.42.83l-2.33,15.36c-.04.23-.48.49-.97.37-12.47-3.15-19.15,1.28-20.63,2.43-.14.11-.36,0-.39-.19"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M722.28,690.13H77.72c-1.19,0-2.16-.93-2.16-2.07s.97-2.07,2.16-2.07h644.56c1.19,0,2.16.93,2.16,2.07s-.97,2.07-2.16,2.07Z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 375.23,
    y: 109.87,
    width: 348.34,
    height: 56.32,
    rx: 7.73,
    ry: 7.73
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 667.03,
    y: 110.21,
    width: 56.32,
    height: 56.32,
    rx: 7.73,
    ry: 7.73
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M692.98,123.24l10.39,13.29c.73.97,1.21,1.77,1.21,2.9,0,1.05-.48,1.85-1.21,2.82l-10.15,13.05c-.81,1.13-2.17,1.93-3.63,1.93-2.26,0-3.95-1.85-3.95-4.03,0-.97.48-2.01,1.13-2.74l8.46-10.96-8.62-11.28c-.72-.89-1.05-1.69-1.05-2.74.08-2.25,1.77-4.03,4.03-4.03,1.53,0,2.66.81,3.38,1.77Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 399.72,
    cy: 137.37,
    r: 6.64
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 425.31,
    cy: 137.37,
    r: 6.64
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 450.91,
    cy: 137.37,
    r: 6.64
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 476.5,
    cy: 137.37,
    r: 6.64
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 502.09,
    cy: 137.37,
    r: 6.64
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 527.69,
    cy: 137.37,
    r: 6.64
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 553.28,
    cy: 137.37,
    r: 6.64
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 578.87,
    cy: 137.37,
    r: 6.64
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M170.39,287.16c-3.31,3.9-10.67,11.47-22.69,15.99-12.01,4.52-15.56,3.76-21.67,2.73-2.83-.48-5.81.34-7.72,2.49-.23.26-.45.53-.67.83-1.29,1.79-2.04,3.99-2.04,6.31v52.8c0,2.89,1.16,5.66,3.22,7.69l47.97,35.14c3.41,3.35,8.88,3.33,12.27-.04l49.46-35.66c2.03-2.02,3.17-4.77,3.17-7.64v-52.3c0-2.38-.78-4.63-2.14-6.45-1.93-2.58-5.26-3.66-8.43-3.06-5.8,1.1-8.72,1.99-20.14-2-13.14-4.59-20.81-13.1-24.2-16.94-.08-.12-1.14-1.72-3.13-1.74-2.11-.02-3.22,1.78-3.27,1.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M192.3,336.19h-3.61v-6.26c0-8.29-6.74-15.04-15.02-15.04s-15.04,6.75-15.04,15.04v6.26h0s-3.61,0-3.61,0c-2.18,0-3.96,1.78-3.96,3.98v29.09c0,2.2,1.78,3.98,3.96,3.98h37.28c2.18,0,3.96-1.78,3.96-3.98v-29.09c0-2.2-1.78-3.98-3.96-3.98ZM163.42,336.19v-6.26c0-5.65,4.59-10.25,10.24-10.25s10.23,4.6,10.23,10.25v6.26h0s-20.48,0-20.48,0h0ZM177.47,356.45c-.92.88-1.5,2.07-1.36,3.33,0,.09.01.18.01.27,0,1.36-1.11,2.47-2.47,2.47s-2.47-1.11-2.47-2.47c0-.09,0-.18.01-.27.14-1.27-.45-2.47-1.37-3.35-1.33-1.27-2.03-3.21-1.57-5.28.45-2.01,2.08-3.65,4.09-4.11,3.63-.83,6.84,1.9,6.84,5.39,0,1.58-.66,3.01-1.72,4.01Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg401UnauthorisedIllustration);
export default __webpack_public_path__ + "static/media/401-unauthorised-illustration.1c4f48679636f337e42754dbfc5a1ba3.svg";
export { ForwardRef as ReactComponent };